import React, { useState } from 'react';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import RadioBox from '../../Radiox';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import { Box, Button, Stack, Typography, Divider } from '@mui/material';
import Grid from '@mui/material/Grid';
import type { ColumnsType } from 'antd/es/table';
import { Card, Radio, Table, Input, Modal, Row, Col } from 'antd';
import { Form } from 'antd';
import CLIENT from '../../../Models/Client';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import SweetAlert from 'sweetalert2';
import axios from 'axios';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
import { PhoneOutlined, PictureOutlined, MoneyCollectOutlined, UserOutlined, IdcardOutlined, HomeOutlined } from '@ant-design/icons'
import SearchInput from '../../SearchInput';
import { Crypter } from '../../../Functions/Security/Crypter';
import FormImage from '../../FormImage';
import DataRelationClient from '../../../Types/DataRelationClient';
import Utilisateur from '../../../Models/Utilisateur';
let Link = require('../../../Data/Data.json');

interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}




const Tab1 = (props: { etatG?: boolean, form?: any, data: DataRelationClient[] }) => {
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));

  const [componentDisabled, setComponentDisabled] = useState<boolean>(true);
  const [idrelation, setidrelation] = useState<boolean>(true);
  const [Reference, setReference] = useState<boolean>(false);
  const [titre, settitre] = useState<boolean>(true);
  const [Sexe, setsexe] = useState<boolean>(true);
  const [nomrel, setnomrel] = useState<boolean>(true);
  const [Prenom, setPrenom] = useState<boolean>(true);
  const [DateNaiss, setDateNaiss] = useState<boolean>(true);
  const [PieceIdebtite, setPieceIdebtite] = useState<boolean>(true);
  const [Adresse, setAdresse] = useState<boolean>(true);
  const [Lieu, setLieu] = useState<boolean>(true);
  const [Expire, setExpire] = useState<boolean>(true);
  const [Tel, setTel] = useState<boolean>(true);
  const [Ratio, setRatio] = useState<boolean>(true);
  const [FormR, SetFormR] = useState<boolean>(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [SearchR, SetSearchR] = useState<string>("");
  // const [check, setcheck] = useState<boolean>(true);
  const handleCancel = () => setPreviewOpen(false);

  const authHeader = useAuthHeader();


  //Initialisation des parametres de recherche
  let searchClient: ParamsPicklist = { CodeAgence: user.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'CODAGE', Choix: 22 }
  let searchClient2: ParamsPicklist = { CodeAgence: user.codage, Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: 'CODAGE', Choix: 22 }
  let searchTitre: ParamsPicklist = { CodeAgence: 'TITRESCLIENT', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
  let searchFiliation: ParamsPicklist = { CodeAgence: 'FILIA', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: "RUBRIQ", Choix: 22 }

  let informationclient = {

    SearchClient: {
      Titre: "recherche client",
      label: "Identifiant  client",
      name: "idClient", params: searchClient
    },
    Searchrelation: {
      Titre: "Recherche relation client",
      label: "Id relation",
      name: "CODREL", params: searchClient
    },
    SearchFiliation: {
      Titre: "Recherche filiation",
      label: "Filiation",
      name: "filiation", params: searchFiliation
    },
    SearchTitre: {
      Titre: "search Titre Relation",
      label: "Titre",
      name: "TitRel", params: searchTitre
    },
    RadioSexe: {
      label: "Genre",
      LibValue1: "M",
      LibValue2: "F",
      name: "Sexe"
    },
    InputNom:
    {
      label: 'Nom relation',
      name: "NomRel"
      //suspend  
    },
    InputPrenom:
    {
      label: 'Prénom',
      name: "Prenom"
    },
    InputDateNaiss:
    {
      label: 'Date naissance',
      name: "dateNais"
    },
    InputPieceIdebtite:
    {
      label: 'Pièce identité',
      name: "cni"
    },
    InputAdresse: {
      label: "Adresse",
      name: "adresRel"
    },
    InputLieu: {
      label: "Lieu de naissance",
      name: "LieuNais"
    },
    InputExpire: {
      label: "Expire le",
      name: "DatExpirCni"
    },
    InputTel: {
      label: "Téléphone",
      name: "TelRel"
    },
    InputRatio: {
      label: "Ratio",
      name: "Ratio"
    },
    Inputplafond: {
      label: "Plafond",
      name: "plafond"
    },

    RadioSignataire: {
      label: "Signataire",
      LibValue1: "OUI",
      LibValue2: "NON",
      name: "Signataire"
    }

  }


  const columns: ColumnsType<DataRelationClient> = [
    {
      title: 'Reférence ',
      dataIndex: 'CODEREL',
      align: 'center',
      ellipsis: true,
      width: 120,
      filteredValue: [SearchR],
      onFilter: (value: any, record: any) => {
        return String(record.idclient)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          String(record.idclient)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Nom)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Prenom)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Tel)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.ville)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.filiation)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Datecre)
            .toLowerCase()
            .includes(value.toLowerCase())
      }
    }
    ,
    {
      title: 'Id Client',
      dataIndex: 'idclient',
      align: 'center',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Nom',
      dataIndex: 'Nom',
      align: 'center',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Prenom',
      dataIndex: 'Prenom',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Téléphone',
      dataIndex: 'Tel',
      align: 'center',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Filiation',
      dataIndex: 'filiation',
      align: 'center',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Photo',
      dataIndex: 'photo',
      align: 'center',
      ellipsis: true,
      width: 150,
      render: (text: any, record: any) => (
        <span>
          <img
            onClick={e => { setPreviewImage(record.RelObject.photo); setPreviewTitle("Preview Image"); setPreviewOpen(true); }}
            style={{ height: 50, width: 50 }}
            src={record.RelObject.photo}
          ></img>
        </span>)
    },
    {
      title: 'Signature',
      dataIndex: 'signature',
      align: 'center',
      ellipsis: true,
      width: 150,
      render: (text: any, record: any) => (
        <span>
          <img
            onClick={e => { setPreviewImage(record.RelObject.signature); setPreviewTitle("Preview Image"); setPreviewOpen(true); }}
            style={{ height: 50, width: 50 }}
            src={record.RelObject.signature}
          ></img>
        </span>)
    },
    {
      title: 'Date Creation',
      dataIndex: 'Datecre',
      align: 'center',
      ellipsis: true,
      width: 150,
    },
    {
      title: "",
      dataIndex: 'RelObject',
      width: 1
    }

  ]



  const onSelectChange = (newSelectedRowKeys: any) => {
    console.log('selectedRowKeys changed: ', props.data[newSelectedRowKeys].RelObject);
    setSelectedRowKeys(newSelectedRowKeys);

    props.form.setFieldsValue(props.data[newSelectedRowKeys].RelObject);

    //datExpirCni
    if (props.data[newSelectedRowKeys].RelObject.IdRel === "" || props.data[newSelectedRowKeys].RelObject.IdRel === null) {
      props.form.setFieldValue('check', false);
    }
    else {
      props.form.setFieldValue('check', true);
    }

    props.form.setFieldValue('dateNais', ReformatDate(props.data[newSelectedRowKeys].RelObject.dateNais));

    props.form.setFieldValue('lib_CODREL', props.data[newSelectedRowKeys].RelObject.NomRel);
    props.form.setFieldValue('DatExpirCni', ReformatDate(props.data[newSelectedRowKeys].RelObject.DatExpirCni));
    props.form.setFieldValue('DatExpirCni', ReformatDate(props.data[newSelectedRowKeys].RelObject.DatExpirCni));
    props.form.setFieldValue('photo', props.data[newSelectedRowKeys].RelObject.photo);
    props.form.setFieldValue('signature', props.data[newSelectedRowKeys].RelObject.signature);

  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };


  //vérification de la date de naissance qui doit etre supérieur à la date actuel
  const handleChangedatenais = (e: any) => {
    const DatteActuel = new Date().toISOString();

    if (e.target.value >= DatteActuel) {
      SweetAlert.fire({ title: "saisie invalide", text: "La date saisie est Supérieure à la Actuelle", icon: "error" });
      props.form.setFieldValue("DATNAI", '');
    }

  };

  //vérification de la date d'expiration de la CNI qui doit etre supérieur à la date actuel
  const handleChangedateexpirecni = (e: any) => {
    const DatteActuel = new Date().toISOString();

    if (e.target.value <= DatteActuel) {
      SweetAlert.fire({ title: "saisie invalide", text: "La date saisie est Inférieure à la Actuelle", icon: "error" });
      props.form.setFieldValue("DateDelcni", '');
    }
  };


  const StartConsulte = async () => {
    let data = Crypter.encrypt(props.form.getFieldValue("IdRel"));
    // let clearNumcli = props.form.getFieldValue("CODREL");
    if (data.length != 0) {

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Link.ApiUrl.GetClient,
        headers: {
          'CypherNumcli': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      axios.request(config)
        .then((response) => {
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));
            if (res.StatutCode == 200) {
              let datas: CLIENT = res.Result.Table[0];

              if (res.Result.Table.length > 0) {

                props.form.setFieldValue('TitRel', datas.TITCLI);
                props.form.setFieldValue('lib_TitRel', res.Result.Table[0].lib_TITCLI);
                props.form.setFieldValue('Sexe', datas.CLSEXE);
                props.form.setFieldValue('NomRel', datas.NOMCLI);
                props.form.setFieldValue('Prenom', datas.PRECLI);
                props.form.setFieldValue('dateNais', ReformatDate(datas.DATNAI));
                props.form.setFieldValue('LieuNais', datas.LIENAI);
                props.form.setFieldValue('cni', datas.numCNI);
                props.form.setFieldValue('DatExpirCni', ReformatDate(datas.DateDelcni));
                props.form.setFieldValue('adresRel', datas.adrDom);
                props.form.setFieldValue('TelRel', datas.telCli);

              } else {
                SweetAlert.fire({ title: "Warning", text: "Client not found", icon: "warning" })
              }
            }
          }
        })
        .catch(function (error: any) {
          SweetAlert.fire({ text: error.message, icon: 'warning', confirmButtonText: 'OK' });

        })

    }
  }


  const ClientNotExist = () => {

    props.form.setFieldValue('IdRel', '');
    props.form.setFieldValue('lib_IdRel', '');
    setidrelation(true);
    settitre(false);
    setsexe(false);
    setnomrel(false);
    setPrenom(false);
    setDateNaiss(false);
    setPieceIdebtite(false);
    setAdresse(false);
    setLieu(false);
    setExpire(false);
    setTel(false);
    SetFormR(true);
    setReference(true);
  }

  const ClientExist = () => {

    settitre(true);
    setsexe(true);
    setnomrel(true);
    setPrenom(true);
    setDateNaiss(true);
    setPieceIdebtite(true);
    setAdresse(true);
    setLieu(true);
    setExpire(true);
    setTel(true);
    SetFormR(false);
    setReference(false);
  }

  const ActiRelCli = () => {

    if (componentDisabled === true) {
      setidrelation(false);
    }
    else if (componentDisabled === false) {
      setidrelation(true);

    }

  }
  //information du client

  const oncheckD = (e: any) => {
    if (e == 'O') {
      setRatio(false);
    }
    else if (e == 'N') {
      setRatio(true);
    }
  }

  const oncheck = (e: any) => {
    if (e == false) {
      ClientNotExist();
    }
    else if (e == true) {
      ClientExist();
    }
  }

  return (
    <div className='tabItem' >
      <div>
        <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
       
            
            {/* Section Identification Client */}
      
                 <legend style={{marginTop:0,marginBottom:0, borderRadius:8,width:'100%'}}> <UserOutlined style={{ color: '#116599' }} />Identification Client</legend>
                  <SearchInput 
                    dissabledCode={props.etatG} 
                    notRequired 
                    width={4} 
                    Titre={informationclient.SearchClient.Titre} 
                    label={informationclient.SearchClient.label} 
                    name={informationclient.SearchClient.name} 
                    Parametre={informationclient.SearchClient.params} 
                    form={props.form} 
                  />
               
                <legend style={{marginTop:0,marginBottom:0, borderRadius:8,width:'100%'}}> <UserOutlined style={{ color: '#116599' }} />  <IdcardOutlined style={{ color: '#52c41a' }} /> Information Relation</legend>
                    
         
              <Grid container spacing={0}>
                <Grid item xs={12} md={6} spacing={0}>
                  <Form.Item 
                    labelCol={{ span: 8 }} 
                    name='check' 
                    label='Client Existant' 
                    style={{ fontWeight: 600 }}
                  >
                    <Radio.Group 
                      defaultValue={true} 
                      onChange={e => { setComponentDisabled(e.target.value); oncheck(e.target.value); }}
                    >
                      <Radio value={true}>OUI</Radio>
                      <Radio value={false}>NON</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Grid>
                <Grid item xs={12} md={6}>
                  <SearInputM 
                    notRequired 
                    ExecuteafterSelect1={StartConsulte} 
                    disabled={Reference} 
                    width={7} 
                    name="IdRel" 
                    Titre="Recherche Relation" 
                    label="Reférence Client" 
                    Parametre={searchClient2} 
                    form={props.form} 
                  />
                </Grid>
              </Grid>
              <Grid container spacing={0}>
                <Grid item xs={12} md={6}>
                  <SearInputM 
                    notRequired 
                    width={7} 
                    disabled={idrelation} 
                    Titre={informationclient.Searchrelation.Titre} 
                    label={informationclient.Searchrelation.label} 
                    name={informationclient.Searchrelation.name} 
                    Parametre={informationclient.Searchrelation.params} 
                    form={props.form} 
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SearInputM 
                    width={7} 
                    Titre={informationclient.SearchFiliation.Titre}
                    label={informationclient.SearchFiliation.label} 
                    name={informationclient.SearchFiliation.name}
                    Parametre={informationclient.SearchFiliation.params} 
                    form={props.form} 
                  />
                </Grid>
              </Grid>
              <Grid container spacing={0}>
                <Grid item xs={12} md={6}>
                  <InputForm 
                    icon={<MoneyCollectOutlined />} 
                    width={7} 
                    money
                    label={informationclient.Inputplafond.label} 
                    name={informationclient.Inputplafond.name} 
                    type='number' 
                  />
                </Grid>
            
              </Grid>
           
                <legend style={{marginTop:0,marginBottom:0, borderRadius:8,width:'100%'}}>  <HomeOutlined style={{ color: '#fa8c16' }} /> Coordonnées et Informations Personnelles</legend>
             

            {/* Section Coordonnées et Informations Personnelles */}
            
              <Grid container spacing={0}>
                {/* Colonne de gauche */}
                <Grid item xs={12} md={6}>
                  <InputForm 
                    width={7} 
                    disabled={nomrel} 
                    label={informationclient.InputNom.label} 
                    name={informationclient.InputNom.name} 
                    type='text' 
                  />
                  <InputForm 
                    disabled={Prenom} 
                    notRequired 
                    width={7} 
                    label={informationclient.InputPrenom.label} 
                    name={informationclient.InputPrenom.name} 
                    type='text' 
                  />
                  <SearInputM 
                    disabled={titre} 
                    notRequired 
                    width={7} 
                    Titre={informationclient.SearchTitre.Titre} 
                    label={informationclient.SearchTitre.label} 
                    name={informationclient.SearchTitre.name} 
                    Parametre={informationclient.SearchTitre.params} 
                    form={props.form} 
                  />
                  <RadioBox 
                    disabled={Sexe} 
                    width={7} 
                    label={informationclient.RadioSexe.label} 
                    name={informationclient.RadioSexe.name} 
                    Value1='M' 
                    Value2='F' 
                    LibValue1={informationclient.RadioSexe.LibValue1} 
                    libVlue2={informationclient.RadioSexe.LibValue2} 
                  />
                  <InputForm 
                    disabled={DateNaiss} 
                    width={7} 
                    label={informationclient.InputDateNaiss.label} 
                    name={informationclient.InputDateNaiss.name} 
                    type='date' 
                    onBlur={handleChangedatenais} 
                  />
                </Grid>
                
                {/* Colonne de droite */}
                <Grid item xs={12} md={6}>
                  <InputForm 
                    disabled={Lieu} 
                    width={7} 
                    label={informationclient.InputLieu.label} 
                    name={informationclient.InputLieu.name} 
                    type='text' 
                  />
                  <InputForm 
                    disabled={PieceIdebtite} 
                    width={7} 
                    label={informationclient.InputPieceIdebtite.label} 
                    name={informationclient.InputPieceIdebtite.name} 
                    type='text' 
                  />
                  <InputForm 
                    onBlur={handleChangedateexpirecni} 
                    disabled={Expire} 
                    width={7} 
                    label={informationclient.InputExpire.label} 
                    name={informationclient.InputExpire.name} 
                    type='date' 
                  />
                  <InputForm 
                    notRequired 
                    disabled={Adresse} 
                    width={7} 
                    label={informationclient.InputAdresse.label} 
                    name={informationclient.InputAdresse.name} 
                    type='text' 
                  />
                  <InputForm 
                    icon={<PhoneOutlined />} 
                    disabled={Tel} 
                    width={7} 
                    label={informationclient.InputTel.label} 
                    name={informationclient.InputTel.name} 
                    type='text' 
                    RegExp={/[0-9]{9}$/gmi} 
                    MessExp='le numéro doit étre de 9 chiffres' 
                  />
                </Grid>
              </Grid>
            
              
                <legend style={{marginTop:0,marginBottom:0, borderRadius:8,width:'100%'}}>   <MoneyCollectOutlined style={{ color: '#eb2f96' }} /> Statut et Droits</legend>
             
            {/* Section Statut et Droits */}
           
              <Grid container spacing={0}>
                <Grid item xs={12} md={4}>
                  <RadioBox 
                    etat={FormR} 
                    width={7} 
                    label={informationclient.RadioSignataire.label} 
                    defaultValue='N'
                    name={informationclient.RadioSignataire.name} 
                    Value1='O' 
                    Value2='N' 
                    LibValue1={informationclient.RadioSignataire.LibValue1}
                    libVlue2={informationclient.RadioSignataire.LibValue2} 
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Form.Item 
                    initialValue={'N'} 
                    labelCol={{ span: 8 }} 
                    name='ayantd' 
                    label='Ayant Droit' 
                    style={{ fontWeight: 600 }}
                  >
                    <Radio.Group onChange={e => { oncheckD(e.target.value); }}>
                      <Radio value='O'>OUI</Radio>
                      <Radio value='N'>NON</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputForm 
                    notRequired 
                    icon={<MoneyCollectOutlined />} 
                    disabled={Ratio} 
                    width={7} 
                    label={informationclient.InputRatio.label} 
                    name={informationclient.InputRatio.name} 
                    type='number' 
                  />
                </Grid>
              </Grid>
            

            {/* Section Documents et Tableau */}
            <Grid container spacing={2}>
              {/* Colonne Documents */}
              <Grid item xs={12} md={4}>
                <Card 
                  title={
                    <Box display="flex" alignItems="center" gap={1}>
                      <PictureOutlined style={{ color: '#13c2c2' }} />
                      <Typography variant="h6">Documents</Typography>
                    </Box>
                  }
                  size="small"
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Box display="flex" flexDirection="column" sx={{ gap: 2, alignItems: 'center' }}>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#666' }}>
                          Photo d'identité
                        </Typography>
                        <FormImage 
                          required 
                          type='image' 
                          label='Photo' 
                          name='photo' 
                          nombre={1} 
                          form={props.form} 
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box display="flex" flexDirection="column" sx={{ gap: 2, alignItems: 'center' }}>
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#666' }}>
                          Signature
                        </Typography>
                        <FormImage 
                          required 
                          type='image' 
                          label='Signature' 
                          name='signature' 
                          nombre={1} 
                          form={props.form} 
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              
              {/* Colonne Tableau */}
              <Grid item xs={12} md={8}>
                <Card 
                  title={
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <Typography variant="h6">Liste des Relations</Typography>
                      <Input.Search 
                        onChange={(e) => { SetSearchR(e.target.value); }} 
                        style={{ width: 300 }} 
                        placeholder="Rechercher..." 
                        size="middle" 
                      />
                    </Box>
                  }
                  size="small"
                >
                  <Table 
                    sticky={true} 
                    bordered={true} 
                    size='small' 
                    rowSelection={{ 
                      ...rowSelection, 
                      selectedRowKeys, 
                      type: 'radio', 
                      getCheckboxProps: (record) => ({ disabled: false }) 
                    }} 
                    columns={columns} 
                    dataSource={props.data} 
                    scroll={{ y: 300, x: 1200 }} 
                  />
                </Card>
              </Grid>
            </Grid>

            <Modal 
              width={800} 
              open={previewOpen} 
              title={previewTitle} 
              footer={null} 
              onCancel={handleCancel}
            >
              <img 
                alt="Aperçu" 
                style={{ width: '100%', maxHeight: 500 }} 
                src={previewImage} 
              />
            </Modal>
            
          </Box>
      
      </div>
    </div>
  );

}
export default Tab1;
